import styled from "styled-components";

export const ListItem = styled.div`
  margin-top: 15px;
`;
